import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { getToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [viewAs, setViewAsState] = useState(() => localStorage.getItem("rsp_view_as") || null);
  const setViewAs = (r) => {
    if (r) localStorage.setItem("rsp_view_as", r);
    else localStorage.removeItem("rsp_view_as");
    setViewAsState(r);
  };

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      setLoading(false);
      return null;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setLoading(false);
      return data;
    } catch (e) {
      clearToken();
      setUser(null);
      setLoading(false);
      return null;
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Logout request failed (clearing session anyway):", e); }
    clearToken();
    setUser(null);
    setViewAs(null);
    window.location.href = "/login";
  };

  const isAdmin = !!(user && (user.is_admin || user.role === "admin"));
  const effectiveRole = isAdmin && viewAs ? viewAs : user?.role;

  return (
    <AuthContext.Provider
      value={{ user, setUser, loading, refresh, logout, isAdmin, viewAs, setViewAs, effectiveRole }}
    >
      {children}
    </AuthContext.Provider>
  );
}
